import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
// import UploadIcon from "@mui/icons-material/Upload";
import Zoom from "react-medium-image-zoom";
import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
// import { useParams } from "react-router-dom";

import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import EmailIcon from "@mui/icons-material/Email";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  // alert(index)
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ResidentManInfoViewTab(props) {
  const navigate = useNavigate();

  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );
  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  // const [ownername, setownername] = React.useState("");
  // const [registrationno, setregistrationno] = React.useState("");
  // const [vehicleno, setvehicleno] = React.useState("");
  const [firstname, setfirstname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [contact, setcontact] = React.useState("");
  // const [relation, setrelation] = React.useState("");
  const [profilePic, setProfilePic] = React.useState("");

  const [email, setemail] = React.useState("");
  const [age, setage] = React.useState("");
  const [family_mem_cnt, setfamily_mem_cnt] = React.useState(0);
  const [flat_cnt, setflat_cnt] = React.useState(0);
  const [, setparkingsloat] = React.useState("");

  const [famlisting, setsetfamlisting] = React.useState([]);
  const [documentList, setDocumentList] = React.useState([]);
  const [tentlist, settentlist] = React.useState([]);

  // const [lengthfam, setlengthfam] = React.useState("");
  // const [firstnmedit, setfirstnmedit] = React.useState("");
  // const [lastnmedit, setlastnmedit] = React.useState("");
  // const [contactedit, setcontactedit] = React.useState("");
  // const [emailidedit, setemailidedit] = React.useState("");
  // const [ageedit, setageedit] = React.useState("");
  // const [familycntedit, setfamilycntedit] = React.useState("");
  // const [flatcntedit, setflatcntedit] = React.useState("");
  const [apartmentList, setApartmentList] = React.useState([]);
  // const [tenentObj, setTenentObj] = React.useState("");

  const [tenentFirstName, setTenentFirstName] = React.useState("");
  const [tenentLastName, setTenentLastName] = React.useState("");
  const [tenentContactNo, setTenentContactNo] = React.useState("");
  const [tenentProfilePic, setTenentProfilePic] = React.useState("");
  const [tenentEmailId, setTenentEmailId] = React.useState("");
  const [tenentAge, setTenentAge] = React.useState(0);

  const [tenentFamilyCnt, setTenentFamilyCnt] = React.useState("");
  const [tenentFamMemList, setTenentFamMemList] = React.useState([]);
  const [tenentVehicleList, setTenentVehicleList] = React.useState([]);
  const [tenentdocList, setTenentdocList] = React.useState([]);

  const [vehilisting, setvehilisting] = React.useState([]);
  // const [lengthvehi, setlengthvehi] = React.useState("");
  const [showLoader] = React.useState(false);

  // For According
  const [expanded, setExpanded] = React.useState(false);
  const handleChange2 = (panel) => (event2, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  // End

  async function viewresident() {
    let bodyFormData = "";

  await  makeGetRequest("resident/getalldetails/" + props.name, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          setfirstname(response.data.data.user_obj.first_name);
          setlastname(response.data.data.user_obj.last_name);
          setcontact(response.data.data.user_obj.contact_no);
          setemail(response.data.data.user_obj.email_id);
          setage(response.data.data.user_obj.age);
          setfamily_mem_cnt(response.data.data.family_count);
          setflat_cnt(response.data.data.apartment_count);
          setApartmentList(response.data.apartmentList);
          console.log("Apartment List");
          console.log(response.data);
          setProfilePic(response.data.data.user_obj.profile_pic);
          // setresidentty(response.data.data.resident_type)
          setparkingsloat(response.data.data.allocated_parking);
          setsetfamlisting(response.data.familyMemberList);
          setvehilisting(response.data.vehicleList);
          settentlist(response.data.tenentList);
          setDocumentList(response.data.data.document_list);
          GetResidentAptNameList(props.name);
          // console.log("response.data.tenentList[0].tenent_id " + response.data.tenentList[0].t);
          if (response.data.tenentList.length > 0) {
            console.log("Tenent Id ", response.data.tenentList[0].resident_id);
            getTenentById(response.data.tenentList[0].resident_id);
            setActiveIndex(response.data.tenentList[0].resident_id);
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [tempId, setTempId] = React.useState("");
  const [activeIndex, setActiveIndex] = React.useState();

  async function getTenentById(tenentId) {
    let bodyFormData = "";
    console.log("In Get Tenent  BY Id");
    await makeGetRequest("resident/getbyid/" + tenentId, bodyFormData)
      .then((response) => {
        console.log(response);
        if (response.status === 201) {
          // alert("Tenent Obj "+response.data.data.apartment_id);
          setTenentFirstName(response.data.data.user_obj.first_name);
          setTenentLastName(response.data.data.user_obj.last_name);
          setTenentContactNo(response.data.data.user_obj.contact_no);
          setTenentEmailId(response.data.data.user_obj.email_id);
          setTenentAge(response.data.data.user_obj.age);
          setTenentFamilyCnt(response.data.data.family_count);
          setTenentProfilePic(response.data.data.user_obj.profile_pic);
          setTenentdocList(response.data.data.document_list);
          getTenentFamiliMemList(tenentId);
          getTenentVehicleList(tenentId);
          setActiveIndex(tenentId);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });

    // var element = document.getElementById("TenentDiv" + tenentId);
    // element.classList.add("activeTenent");

    // if (tempId !== "") {
    //   alert("In Temp Id");
    //   var element2 = document.getElementById(tempId);
    //   element2.classList.remove("activeTenent");
    // }
    // setTempId("TenentDiv" + tenentId);
  }

  async function getTenentFamiliMemList(tenentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "familymember/getbyresidentuser/" + tenentId + "/true",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log("Family Member Data");
          console.log(response.data);
          // setTenentFamMemlength(response.data.data.length)
          setTenentFamMemList(response.data.data);
        } else {
          // setloading(false)
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", "more error details", "warning");
      });
  }

  //all familimemlisting
  async function getTenentVehicleList(tenentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "vehicle/getbyresidentuser/" + tenentId + "/true",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data);
          setTenentVehicleList(response.data.data);
        } else {
          // setloading(false)
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [residentAptNamesList, setResidentAptNamesList] = React.useState([]);

  async function GetResidentAptNameList(residentId) {
    let bodyFormData = "";

    await makeGetRequest(
      "/apartment/getaptnameofresident/" + residentId,
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data);
          // setTenentFamMemlength(response.data.data.length)
          setResidentAptNamesList(response.data.data);
        } else {
          // setloading(false)
          swal("There was an error!", response.messageupload, "warning");
        }
      })
      .catch((err) => {
        // setloading(false)
        swal("There was an error!", "more error details", "warning");
      });
  }

  useEffect(() => {
    viewresident();
  }, []);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div>
        <div className="providerOuter">
          <div className="providerOutProfilDiv">
            <Zoom>
              <div className="provideImgDiv">
                {profilePic ? (
                  <img src={profilePic} />
                ) : (
                  <img src={defaultProfilePic} />
                )}
              </div>
            </Zoom>
            <h4>
              {firstname} {lastname}{" "}
            </h4>
            <p className="ageText">{age} Year Old </p>
            {apartmentList.map((option, index) => (
              <span
                className="ageSubText forOwnerColorGreen"
                key={index}
                onClick={() => navigate("/ApartmentHistory")}
              >
                {option.uniq_apt_name}{" "}
                  <em className="wingsSubTex greenTextOwner">{option.occupancy_type}</em>
                {/* ) : (
                  <em className="wingsSubTex">Tenent</em>
                )} */}
              </span>
            ))}
            {/* <div className="ratingDiv">
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarBorderIcon />
            </div> */}
          </div>
        </div>
        <div
          className="addResiTabStMain fullWidthTabs"
          style={{ marginTop: 50, float: "left" }}
        >
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="scrollable auto tabs example"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Owner Details" {...a11yProps(0)} />
                {/* <Tab label="Family Details" {...a11yProps(1)} /> */}
                <Tab label="Tenant Details" {...a11yProps(1)} />
                {/* <Tab label="Vehicle Details" {...a11yProps(3)} /> */}
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Grid container spacing={0} style={{ marginTop: "50px" }}>
                <Grid item xs={12} md={6}>
                  <div className="tabViewOfProvider">
                    <ul>
                      <li>
                        <span>Phone Number</span> <b>{contact}</b>
                      </li>
                      <li>
                        <span>Email Id</span> <b>{email}</b>
                      </li>
                      {/* <li>
                      <span>Address</span>{" "}
                      <b>2972 Westheimer Rd. Santa Ana, Illinois 85486 </b>
                    </li> */}
                      <li>
                        <span>Family Members</span>{" "}
                        <b>{family_mem_cnt} Members</b>
                      </li>
                      <li>
                        <span>Apartments</span> <b>{flat_cnt}</b>
                      </li>
                      {/* <li>
                        <span>Parking Slot</span> <b>{parkingsloat}</b>
                      </li> */}
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="tabViewOfProviderRight">
                    <h4 className="doquProviderHed">Documents</h4>

                    {documentList.length>0 ? (
                      <>
                        {documentList.map((option, index) => (
                          <div className="doquOut" key={index}>
                            <div className="doquView1">
                              <Zoom>
                                <div className="doquView">
                                  {option.split(".").pop() == "txt" ? (
                                    <img src={txtImage} />
                                  ) : option.split(".").pop() == "pdf" ? (
                                    <img src={pdfImage} />
                                  ) : option.split(".").pop() == "docx" ||
                                    option.split(".").pop() == "doc" ? (
                                    <img src={wordImage} />
                                  ) : option.split(".").pop() == "xls" ||
                                    option.split(".").pop() == "xlsx" ? (
                                    <img src={excelImage} />
                                  ) : (
                                    <img src={option} />
                                  )}
                                </div>
                              </Zoom>
                              <span>
                                <a href={option}>{option.split("/").pop()} </a>
                              </span>
                            </div>
                            {/* <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div> */}
                          </div>
                        ))}
                      </>
                    ) : (
                      <div>No Documents Uploaded...</div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  {/* {/ According Start /} */}

                  <div className="acordingViewMain persnlInfoAcordingMain">
                    <Accordion
                      expanded={expanded === "panel1"}
                      onChange={handleChange2("panel1")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography>Family Details</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="acordingCont">
                          <div className="familyMemDetail familyMemDetailMain">
                            <h4
                              className="doquProviderHed"
                              style={{ textAlign: "left" }}
                            >
                              Family Details
                            </h4>
                            <Grid
                              container
                              spacing={3}
                              style={{ marginTop: "20px" }}
                            >
                              {famlisting ? (
                                <>
                                  {famlisting.map((option, index) => (
                                    <Grid item xs={12} md={6}>
                                      <div
                                        className="familyMemDetailsMain"
                                        key={index}
                                      >
                                        <div className="familyMemDetailsInner">
                                          <div className="familyMemDetailsTop">
                                            <div className="familyMemDetailsProfile">
                                              <Zoom>
                                                {option.user_obj.profile_pic ? (
                                                  <img
                                                    src={
                                                      option.user_obj
                                                        .profile_pic
                                                    }
                                                  />
                                                ) : (
                                                  <img
                                                    src={defaultProfilePic}
                                                  />
                                                )}
                                              </Zoom>
                                            </div>
                                            <h4>
                                              {option.user_obj.first_name}{" "}
                                              {option.user_obj.last_name}
                                            </h4>
                                            <span>
                                              ({option.relation}) {option.user_obj.age} Year old
                                            </span>
                                          </div>
                                          <div className="familyMemDetailsDetels ">
                                            <span>
                                              <LocalPhoneIcon />{" "}
                                              <b>
                                                {option.user_obj.contact_no}
                                              </b>
                                            </span>
                                            <span>
                                              <EmailIcon />{" "}
                                              {option.user_obj.email_id}
                                            </span>
                                            <span className="flatWingNo">
                                            <MeetingRoomIcon /> {option.apartment_no}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                  ))}
                                </>
                              ) : (
                                <div></div>
                              )}
                            </Grid>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      expanded={expanded === "panel2"}
                      onChange={handleChange2("panel2")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                      >
                        <Typography>Vehicle Details</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="acordingCont">
                          <div className="vehicelAndDoquMain">
                            <div className="vehiclMainDetails">
                              <h4 className="doquProviderHed">
                                Vehicle Details
                              </h4>
                              {vehilisting ? (
                                <>
                                  {vehilisting.map((option, index) => (
                                    <div
                                      className="vehicelAndDoquIner"
                                      key={index}
                                    >
                                      <div className="tabViewOfProvider">
                                        <ul>
                                          {/* <label>Vehicle {index + 1}</label> */}
                                          <li>
                                            <span>Owner Name</span>{" "}
                                            <b>{option.vehicle_owner_name}</b>
                                          </li>
                                          <li>
                                            <span>Vehicle Type</span>{" "}
                                            <b>{option.vehicle_type}</b>
                                          </li>
                                          <li>
                                            <span>Vehicle Number</span>{" "}
                                            <b>{option.vehicle_no}</b>
                                          </li>
                                        </ul>
                                      </div>
                                      {option.document_list ? (
                                        <div className="tabViewOfProviderRight">
                                          {option.document_list.map(
                                            (option) => (
                                              <div className="doquOutMain">
                                                <div className="doquOut">
                                                  <div className="doquView1">
                                                    <Zoom>
                                                      <div className="doquView">
                                                        {option
                                                          .split(".")
                                                          .pop() == "txt" ? (
                                                          <img src={txtImage} />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "pdf" ? (
                                                          <img src={pdfImage} />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "docx" ||
                                                          option
                                                            .split(".")
                                                            .pop() == "doc" ? (
                                                          <img
                                                            src={wordImage}
                                                          />
                                                        ) : option
                                                            .split(".")
                                                            .pop() == "xls" ||
                                                          option
                                                            .split(".")
                                                            .pop() == "xlsx" ? (
                                                          <img
                                                            src={excelImage}
                                                          />
                                                        ) : (
                                                          <img src={option} />
                                                        )}
                                                      </div>
                                                    </Zoom>
                                                    <span>
                                                      <a href={option}>
                                                        {option
                                                          .split("/")
                                                          .pop()}
                                                      </a>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      ) : (
                                        <div></div>
                                      )}
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div></div>
                              )}
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  {/* {/ According End /} */}
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value={value} index={1} className="tenentNewStyleMain">
              <Grid container spacing={3} style={{ marginTop: "50px" }}>
                {tentlist.length > 0 ? (
                  <>
                    <Grid item xs={12} md={4}>
                      <div className="tenentLeftContentMain">
                        {tentlist.map((option, index) => (
                          <ul>
                            <li
                              key={option.resident_id}
                              onClick={() => getTenentById(option.resident_id)}
                              className={
                                option.resident_id === activeIndex
                                  ? "activeTenent"
                                  : ""
                              }
                            >
                              <div className="tenantDProfile">
                                <Zoom>
                                  {option.user_obj.profile_pic?
                                  <img src={option.user_obj.profile_pic} />
                                  :
                                  <img img src={defaultProfilePic} />}
                                </Zoom>
                              </div>
                              <h4>
                                {option.user_obj.first_name}{" "}
                                {option.user_obj.last_name}
                              </h4>
                              <span>{option.uniq_apt_name}</span>
                            </li>
                          </ul>
                        ))}
                      </div>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <div className="acordingViewMain tenentRightContentMain">
                        <div className="acordingCont resiManagInfoCont">
                          <div className="familyMemDetailsTop tenentInfoPro">
                            <div className="familyMemDetailsProfile">
                              <Zoom>
                                {tenentProfilePic ? (
                                  <img src={tenentProfilePic} />
                                ) : (
                                  <img src={defaultProfilePic} />
                                )}
                              </Zoom>
                            </div>
                            <h4>
                              {tenentFirstName} {tenentLastName}
                            </h4>
                            <span>{tenentAge} Year Old </span>
                          </div>
                          <div className="tabViewOfProvider fullWidthComp">
                            <ul>
                              <li>
                                <span>Phone Number</span>{" "}
                                <b>{tenentContactNo}</b>
                              </li>
                              <li>
                                <span>Email Id</span> <b>{tenentEmailId}</b>
                              </li>

                              <li>
                                <span>Family Members</span>{" "}
                                <b>{tenentFamilyCnt} Members</b>
                              </li>
                            </ul>
                          </div>
                          <div className="tabViewOfProviderRight">
                            <h4 className="doquProviderHed">Documents</h4>
                            <div className="doquOutMain">
                              {tenentdocList.map((option) => (
                                <div className="doquOut">
                                  <div className="doquView1">
                                    <Zoom>
                                      <div className="doquView">
                                        {option.split(".").pop() == "txt" ? (
                                          <img src={txtImage} />
                                        ) : option.split(".").pop() == "pdf" ? (
                                          <img src={pdfImage} />
                                        ) : option.split(".").pop() == "docx" ||
                                          option.split(".").pop() == "doc" ? (
                                          <img src={wordImage} />
                                        ) : option.split(".").pop() == "xls" ||
                                          option.split(".").pop() == "xlsx" ? (
                                          <img src={excelImage} />
                                        ) : (
                                          <img src={option} />
                                        )}
                                      </div>
                                    </Zoom>
                                    <span>
                                      <a href={option}>
                                        {option.split("/").pop()}{" "}
                                      </a>
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <Accordion
                          expanded={expanded === "panel1"}
                          onChange={handleChange2("panel1")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography>Family Details</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="acordingCont">
                              <div className="familyMemDetail familyMemDetailMain">
                                <h4
                                  className="doquProviderHed"
                                  style={{ textAlign: "left" }}
                                >
                                  Family Details
                                </h4>
                                <Grid
                                  container
                                  spacing={3}
                                  style={{ marginTop: "20px" }}
                                >
                                  {tenentFamMemList.map((option) => (
                                    <Grid item xs={12} md={6}>
                                      <div className="familyMemDetailsMain">
                                        <div className="familyMemDetailsInner">
                                          <div className="familyMemDetailsTop">
                                            <div className="familyMemDetailsProfile">
                                              <Zoom>
                                                {option.user_obj.profile_pic ? (
                                                  <img
                                                    src={
                                                      option.user_obj
                                                        .profile_pic
                                                    }
                                                  />
                                                ) : (
                                                  <img
                                                    src={defaultProfilePic}
                                                  />
                                                )}
                                              </Zoom>
                                            </div>
                                            <h4>
                                              {option.user_obj.first_name}{" "}
                                              {option.user_obj.last_name}
                                            </h4>
                                            <span>
                                              ({option.relation}) {option.user_obj.age} Year Old
                                            </span>
                                          </div>
                                          <div className="familyMemDetailsDetels smallBox">
                                            <span>
                                              <LocalPhoneIcon />{" "}
                                              <b>
                                                {option.user_obj.contact_no}
                                              </b>
                                            </span>
                                            <span>
                                              <EmailIcon />{" "}
                                              <b>{option.user_obj.email_id}</b>
                                            </span>
                                            <span className="flatWingNo">
                                            {/* <MeetingRoomIcon /> {option.apartment_no} */}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>

                        <Accordion
                          expanded={expanded === "panel2"}
                          onChange={handleChange2("panel2")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography>Vehicle Details</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="acordingCont">
                              <div className="vehicelAndDoquMain">
                                <div className="vehiclMainDetails">
                                  <h4 className="doquProviderHed">
                                    Vehicle Details
                                  </h4>
                                  {tenentVehicleList.map((option) => (
                                    <div className="vehicelAndDoquIner">
                                      <div className="tabViewOfProvider">
                                        <ul>
                                          <li>
                                            <span>Owner Name</span>{" "}
                                            <b>{option.vehicle_owner_name}</b>
                                          </li>
                                          <li>
                                            <span>Vehicle Type</span>{" "}
                                            <b>{option.vehicle_type}</b>
                                          </li>
                                          <li>
                                            <span>Vehicle Number</span>{" "}
                                            <b>{option.vehicle_no}</b>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="tabViewOfProviderRight">
                                        {option.document_list ? (
                                          <div className="doquOutMain">
                                            {option.document_list.map(
                                              (docUrl) => (
                                                <div className="doquOut">
                                                  <div className="doquView1">
                                                    <Zoom>
                                                      <div className="doquView">
                                                        {docUrl
                                                          .split(".")
                                                          .pop() == "txt" ? (
                                                          <img src={txtImage} />
                                                        ) : docUrl
                                                            .split(".")
                                                            .pop() == "pdf" ? (
                                                          <img src={pdfImage} />
                                                        ) : docUrl
                                                            .split(".")
                                                            .pop() == "docx" ||
                                                          docUrl
                                                            .split(".")
                                                            .pop() == "doc" ? (
                                                          <img
                                                            src={wordImage}
                                                          />
                                                        ) : docUrl
                                                            .split(".")
                                                            .pop() == "xls" ||
                                                          docUrl
                                                            .split(".")
                                                            .pop() == "xlsx" ? (
                                                          <img
                                                            src={excelImage}
                                                          />
                                                        ) : (
                                                          <img src={docUrl} />
                                                        )}
                                                      </div>
                                                    </Zoom>
                                                    <span>
                                                      <a href={docUrl}>
                                                        {docUrl
                                                          .split("/")
                                                          .pop()}{" "}
                                                      </a>
                                                    </span>
                                                  </div>
                                                  {/* <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div> */}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        ) : (
                                          <div></div>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} md={12}>
                    <div className="noTanantAddedTx">No Tenant Allocated</div>
                  </Grid>
                )}
              </Grid>
            </TabPanel>
          </Box>
        </div>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}

    </>
  );
}

export default ResidentManInfoViewTab;
